export const locale = {
  GLOBAL: {
    Title: "MesajLand",
    PostalCode: "Posta Kodu",
    postalCodes: "Posta Kodları",
    selectedPostalCodes: "Seçilen Posta Kodları",
    MciNumberCount: "MCI Hat Sayısı",
    MtuNumberCount: "Irancell Hat Sayısı",
    TotalCount: "Toplam Adet",
    Coefficient: "Katsayı",
    Back: "Geri",
  },
  ERRORS: {
    PhoneIsNotValid:
      "Girilen telefon numarası geçerli değil: örnek 09101234567",
    InvalidNumber: "Girilen sayı geçerli değil",
    NoSelectedLineNumber: "Gönderici hattı seçin.",
    EmptyText: "Lütfen mesaj metnini girin.",
    UnknownError: "Bilinmeyen hata",
    TryAgain: "Lütfen biraz sonra tekrar deneyin.",
    NoAccountCharge: "Yetersiz bakiye",
    NoAccess: "Erişiminiz yok.",
    PleasebyeAPlane: "Lütfen bir plan satın alın.",
    PleaseChargeYourAccount: "Lütfen hesabınızı şarj edin.",
    AccessDenied: "Erişim engellendi.",
    AccessDeniedDescription: "Daha fazla bilgi için destek ile iletişime geçin",
    Error: "Hata",
    InvalidText: "Geçersiz metin",
    InvalidTextContainsLink: "Sadece servis hatları link içerebilir.",
  },
  INFOS: {
    SuccessSentSms: "Mesaj gönderildi",
    SmsRequestInQueue: "Mesajınız yönetici onayı sonrası gönderilecek",
    SendData: "Gönderim Bilgileri",
    CheckData: "Aşağıdaki bilgileri okuyun ve onaylayın.",
  },
  TOBE: {
    to: "alıcı ",
    from: "gönderen ",
  },
  FORMS: {
    DestinationPhone: "Alıcı Telefon Numarası",
    TestDestinationPhone: "Test Telefon Numarası",
    SourceNumber: "Gönderici Numara",
    Text: "Mesaj",
    CharCount: "Karakter Sayısı",
    FarsiCharCount: "Farsça Karakter Sayısı",
    EnglishCharCount: "İngilizce Karakter Sayısı",
    Send: "Gönder",
    SendTime: "Gönderim Zamanı",
    SendTest: "Test Gönder",
    SendToTestNumber: "Test Numarasına Gönder",
    SmsCount: "SMS Adedi",
    SmsLang: "Mesaj Dili",
    Add: "Ekle",
    FromFile: "Dosyadan Ekle",
    TestNumber: "Test Numarası",
    Test: "Test",
    ServiceRelated: "Servis Hattı",
    Price: "Fiyat",
    NumbersCount: "Numara Adedi",
    NumbersCountToSend: "Mesaj gönderilecek numara sayısı",
    Search: "Ara",
    Title: "Başlık",
    RequestTime: "Talep Zamanı",
    RequestInformation: "Talep Bilgileri",
    CreateNewPhoneBook: "Yeni Telefon Defteri Oluştur",
  },
  BUTTONS: {
    OK: "Tamam",
    AccountCharge: "Hesap Şarj Et",
    Reports: "Raporlar",
    RemoveAll: "Hepsini Sil",
    BuyAPlane: "Plan Satın Al",
    Accept: "Onayla",
    Reject: "Reddet",
    Yes: "Evet",
    No: "Hayır",
    Create: "Oluştur",
    New: "Yeni",
    Save: "Kaydet",
    Delete: "Sil",
    More: "Daha Fazla",
    TryAgain: "Tekrar Dene",
    Close: "Kapat",
    RollBack: {
      back: "Önceki kullanıcıya dön",
      goToMainUser: "Ana kullanıcıya dön",
      CurrentUser: "Mevcut Kullanıcı",
    },
  },
  DIALOGS: {
    Waiting: "Lütfen bekleyin",
    RejectItQuestion: "Reddedilsin mi?",
    AcceptItQuestion: "Onaylansın mı?",
    Rejected: "Reddedildi",
    Accepted: "Onaylandı",
    Error: "Hata",
  },
  CONFIRM: {
    Delete: "Silmek istediğinizden emin misiniz?",
    DeleteA: "{a} silmek istediğinizden emin misiniz?",
    DeleteALL: "Hepsini silmek istediğinizden emin misiniz?",
  },
  LANGUAGE: {
    English: "İngilizce",
    Persian: "Farsça",
  },
    language: {
    selectAll: "Tümünü Seç",
    lang: {
      fa: "Farsça",
      ar: "Arapça",
      ar_ae: "Arapça (BAE)",
      ar_iq: "Arapça (Irak)",
      en_US: "İngilizce (ABD)",
      en_GB: "İngilizce (BK)",
      de: "Almanca",
      fr: "Fransızca",
      zh_CN: "Basitleştirilmiş Çince",
      zh_TW: "Geleneksel Çince",
      tr: "Türkçe",
      ru: "Rusça",
      hy: "Ermenice",
    },
    only_manual_now: "Şu anda sadece manuel çeviri mümkün",
    ai_coming_soon: "Yapay zeka çevirisi yakında aktif olacak",
    got_it: "Anladım",
    origin_language: "Kaynak Dil",
    target_languages: "Hedef Diller",
    remove_all: "Tüm Dilleri Kaldır",
    translation_method: "Çeviri Yöntemini Seçin",
    manual_translation: "Manuel Çeviri",
    ai_translation: "Yapay Zeka Çevirisi",
    coming_soon: "Yakında",
    source_language_updated: "Kaynak dil güncellendi",
    error_changing_source_language: "Kaynak dil değiştirilirken hata oluştu",
    source_language_created: "Yeni kaynak dil oluşturuldu",
    languages_saved: "Yeni diller kaydedildi",
    error_saving_languages: "Diller kaydedilirken hata",
    error_loading_language: "Dil yüklenirken hata",
    languages_removed: "Kaldırılan diller",
    new_languages_to_save: "Kaydedilecek yeni diller",
    saved: "Kaydedildi",
    management_langs: "Dil Yönetimi",
    add_langs: "Dil Ekle",
    change_language: "Dili Değiştir",
    visit_card: "Kartvizit",
    translate_to: "Şuna Çevir",
    main_language: "Dil",
    no_languages_available: "Kullanılabilir dil yok",
    return_to_default: "Varsayılan Dile Dön",
    translate: "Çevir",
    changes_pending: "Değişikliklerin uygulanması bekleniyor",
    apply_changes: "Değişiklikleri Uygula",
    cancel_changes: "İptal",
  },
  LISTS: {
    NoData: "Veri yok",
    NoDataFound: "Veri bulunamadı",
    NoDataFoundFor: "{a} için veri bulunamadı",
    NoPhoneNumber: "Numara bulunamadı",
    NoPostalCode: "Posta kodu bulunamadı",
    AddANumber: "Numara ekleyin",
    City: "Şehir",
    AddedBefore: "Daha önce eklendi",
  },
  PAGES: {
    SendSms: "SMS Gönder",
    MapSms: "Harita ile Gönderim",
    PhoneBook: "Telefon Defteri",
  },
  MONETARY: {
    Rial: "Riyal",
  },
  HINTS: {
    SendMessageTitle:
      "Başlık isteğe bağlıdır. Daha önce gönderdiğiniz mesajların başlıklarını kullanarak metni otomatik doldurabilirsiniz. Başlık mesajda gönderilmez, sadece raporlama ve öneriler için kullanılır.",
    SendMessageTime:
      "Gönderim zamanı, mesajınızın gönderim kuyruğuna girdiği zamandır. Yönetici onaylamazsa mesaj gönderilmez.",
    CreatePhoneBook:
      "SMS gönderirken numaraları eklemek için bu isim kullanılacak.",
  },
  TOASTS: {
    SuccessCreate: "Başarıyla oluşturuldu",
    FailedCreated: "Oluşturma hatası",
    SuccessDelete: "Silindi",
    FailedDelete: "Silme hatası",
    SuccessEdit: "Düzenlendi",
    FailedEdit: "Düzenleme hatası",
    AddedSuccess: "Eklendi",
    AddedFailed: "Ekleme hatası",
  },
  WALLET: {
    CustomCharge: "İstediğiniz Tutar",
    GateWay: "Ödeme Kapısı",
    Price: "Tutar",
    Details: [
      "Girilen tutara %9 vergi eklenecek.",
      "Lütfen tutarı dikkatle girin, yatırılan para iade edilmez.",
    ],
    noGateWay: "Sizin için ödeme kapısı tanımlanmamış.",
    PriceNotInRange: "Tutar {min} ile {max} Riyal arasında olmalıdır.",
    Pay: "Öde",
    ErrorOnRedirectToGateWay: "Ödeme sayfasına yönlendirme hatası",
    ChargeWalletButtonDescription: "+ butonuna tıklayarak hesabınızı şarj edin",
  },
  login: {
    phoneField: {
      placeholderIran: "9 ile başlayın (örnek: +98 912 345 6789)",
      placeholderDefault: "Telefon numaranızı girin",
      maxDigitsError: "En fazla {count} rakam!",
      iranMustStartWith9: "Cep numarası 9 ile başlamalı (örnek: 912…)",
    },
    signup_button: "Kayıt oluyorum!",
    forget_password_title: "Şifremi Unuttum",
    register_title: "Ücretsiz Kayıt",
    login_title: "Giriş",
    back: "Geri",
    username_label: "Cep Telefonu / Kullanıcı Adı",
    otp_resend_button: "Kodu Tekrar Gönder",
    password_label: "Şifre",
    password_hint: "En az 8 karakter",
    name_label: "Ad",
    name_rule: "En az 3 karakter",
    lastname_label: "Soyad",
    phone_label: "Cep Telefonu",
    nid_label: "Kimlik Numarası",
    parent_phone_label: "Tanıtan Cep (isteğe bağlı)",
    terms_and_conditions_message:
      "Kayıt olarak Reklam Terminali kurallarını kabul etmiş olursunuz.",
    terms_and_conditions_link: "Kurallar ve Şartlar",
    close: "Kapat",
    forgot_password_link: "Şifrenizi mi unuttunuz?",
    change_password: "Şifre Değiştir",
    register_button: "Kayıt Ol",
    login_button: "Giriş Yap",
    login_with_google: "Google ile Giriş",
    login_with_sms: "SMS ile Giriş",
    login_with_password: "Şifre ile Giriş",
    already_registered: "Zaten kayıtlı mısınız?",
    login_here: "Giriş",
    no_account: "Hesabınız yok mu?",
    signup_now: "Hemen kayıt olun!",
    more_info: "Daha Fazla Bilgi",
    文本_login: "Giriş",
    文本_register: "Kayıt",
    required_field: "Bu alan zorunludur.",
    min_8_char: "Alan 8 karakterden kısa",
    required: "Bu alan zorunludur",
    min_3_char: "En az 3 karakter",
    max_50_char: "En fazla 50 karakter",
    no_internet: "İnternete bağlı değilsiniz",
    no_phone_entered: "Numara girmediniz",
    otp_sent_successfully: "Doğrulama kodu başarıyla gönderildi.",
    please_register_first: "Lütfen önce kayıt olun!",
    wait_3_min: "Lütfen 3 dakika bekleyin ve tekrar deneyin.",
    login_successful: "Başarıyla giriş yaptınız",
    internet_connection_error: "İnternet bağlantı sorunu!",
    agree_to_terms_error: "Kuralları kabul etmediniz!",
    otp_sent_successfully_register: "Doğrulama kodu gönderildi.",
    error: "Hata",
    registration_nid_required_notice:
      "Yüksek güvenlik ve dolandırıcılık önleme amacıyla, Reklam Terminali’nde kayıt için kimlik numarası zorunludur.",
  },
  home: {
    title: "Ana Sayfa",
    selectSystem: "Sistem Seç",
    yourPoints: "Puanlarınız",
    discountCodes: "İndirim Kodları",
    all: "Tümü",
    discounts: "İndirimler",
    systemGuide: "Sistem Kılavuzu",
    yourPointsDynamic: "Puanınız: {points}",
    confirm: "Onayla",
    copy: "Kopyala",
  },
  badges: {
    free: "Ücretsiz",
    preRegister: "Ön Kayıt",
    comingSoon: "Yakında",
    testVersion: "Test Sürümü",
  },
  services: {
    qrLand: {
      title: "QR Land Sistemi",
      description: "Dinamik QR Kod Oluşturma",
      property: {
        0: "Reklam türü ve konumunu inceleme ve seçme",
        1: "Sinema reklam türlerini inceleme ve seçme",
        2: "Komisyon veya ek ücret ödemeye gerek yok",
        3: "Sinema reklamlarının tek merkezden yönetimi",
      },
    },
    payamak: {
      title: "MesajLand Sistemi",
      description: "Toplu Promosyon SMS",
      property: {
        0: "Toplu SMS gönderimi",
        1: "Güncel numara bankası",
        2: "Müşteri kulübüne SMS gönderimi",
        3: "Tüm web siteleri ve yazılımlarla entegrasyon",
      },
    },
    robot: {
      title: "Robot Land Sistemi",
      description: "Tüm numaralar, ilanlar ve panellerin aynı anda yönetimi",
      property: {
        0: "Toplu ve grup ilan kaydı",
        1: "Zamanlı, kademeli ve akıllı ilan yönetimi",
        2: "Sınırsız numara kiralama ve ekleme",
        3: "Tüm ilanların aynı anda kayıt ve yönetimi",
      },
    },
    infoLand: {
      title: "Info Land",
      description: "2500’den fazla güncel meslek veri tabanı",
      property: {
        0: "Tüm meslek bilgileri mevcut",
        1: "Şehir ve illere göre sınıflandırma",
        2: "Ülke genelinde tüm mesleklerin veri tabanı",
        3: "Tüm veri tabanlarının örneklerini inceleme imkanı",
      },
    },
    graphic: {
      title: "Grafik Land Sistemi",
      description: "Sıfırdan yüze grafik tasarım ve video",
      property: {
        0: "Logo ve kırtasiye tasarımı",
        1: "Baskı ve paketleme hizmetleri",
        2: "Katalog, broşür ve kutu tasarımı",
        3: "Her boyutta banner tasarımı ve baskı",
      },
    },
    bestWebLand: {
      title: "Best Web Land Sistemi",
      description: "Web sitesi tasarım, destek ve SEO",
      property: {
        0: "İçerik SEO",
        1: "Sayfa dışı SEO",
        2: "Teknik SEO",
        3: "Sayfa içi SEO",
      },
    },
    onlineShop: {
      title: "Online Mağaza Oluşturucu",
      description: "Dijital dünyaya sadece birkaç tık uzakta",
      badge: "Satış Ortaklığı",
      property: {
        0: "İçerik SEO",
        1: "Sayfa dışı SEO",
        2: "Teknik SEO",
        3: "Sayfa içi SEO",
      },
    },
    social: {
      title: "Sosyal Medya Reklamları",
      description: "En iyi sayfaları ve kanalları inceleme ve seçme",
      property: {
        0: "Yüksek ziyaretçili tüm sayfaları inceleme",
        1: "Tüm reklamların tek merkezden yönetimi",
        2: "Komisyon veya ek ücret yok",
        3: "Beğendiğiniz sayfalarda online reklam siparişi",
      },
    },
    billboard: {
      title: "Online Billboard Kiralama",
      description: "Aracısız ve hedefli billboard seçimi",
      property: {
        0: "Billboard konum ve türünü inceleme",
        1: "Tüm billboardların yönetimi",
        2: "Billboard sahibiyle doğrudan iletişim",
        3: "Komisyon veya ek ücret yok",
      },
    },
    internationalMedia: {
      title: "Ulusal Medya Reklamları",
      description: "TV ve radyoda reklam inceleme ve yayınlama",
      property: {
        0: "Yayın zamanını inceleme ve seçme",
        1: "TV reklam türlerini inceleme ve seçme",
        2: "Radyo reklam türlerini inceleme ve seçme",
        3: "Programa özel reklam seçimi",
      },
    },
    transport: {
      title: "Taşımacılık Filosu Reklamları",
      description: "Havalimanı, tren istasyonu, otobüs ve metro",
      property: {
        0: "Reklam türü ve konumunu inceleme ve seçme",
        1: "Metro reklam türlerini inceleme ve seçme",
        2: "Komisyon veya ek ücret yok",
        3: "Metro reklamlarının tek merkezden yönetimi",
      },
    },
    cinema: {
      title: "Görsel Medya Reklamları",
      description: "Sinema ve video paylaşım sitelerinde reklam",
      property: {
        0: "Reklam türü ve konumunu inceleme ve seçme",
        1: "Sinema reklam türlerini inceleme ve seçme",
        2: "Komisyon veya ek ücret yok",
        3: "Sinema reklamlarının tek merkezden yönetimi",
      },
    },
    estate: {
      title: "Online Emlak Sistemi",
      description: "Dosya, danışman ve müşteri yönetimi",
      property: {
        0: "Reklam türü ve konumunu inceleme ve seçme",
        1: "Sinema reklam türlerini inceleme ve seçme",
        2: "Komisyon veya ek ücret yok",
        3: "Sinema reklamlarının tek merkezden yönetimi",
      },
    },
    AIGeneration: {
      title: "Yapay Zeka Sistemi",
      description: "Resim oluşturma, sohbet botu",
    },
    ShortLink: {
      title: "Kısa Link Sistemi",
      description: "Kısa link oluşturma",
    },
    customer: {
      title: "Online Müşteri Yönetim Sistemi",
      description: "Yönetim, destek ve sadık müşteri oluşturma",
      property: {
        0: "Reklam türü ve konumunu inceleme ve seçme",
        1: "Sinema reklam türlerini inceleme ve seçme",
        2: "Komisyon veya ek ücret yok",
        3: "Sinema reklamlarının tek merkezden yönetimi",
      },
    },
    internetBroadcasting: {
      title: "İnternet Reklam Yönetimi",
      description: "Google Ads, tıklama başı reklam, sponsorlu makale",
      property: {
        0: "Reklam türü ve konumunu inceleme ve seçme",
        1: "Sinema reklam türlerini inceleme ve seçme",
        2: "Komisyon veya ek ücret yok",
        3: "Sinema reklamlarının tek merkezden yönetimi",
      },
    },
    emailMarketing: {
      title: "E-posta Pazarlama Sistemi",
      description: "Ülkedeki tüm işletmelere promosyon e-postası gönderimi",
      property: {
        0: "Reklam türü ve konumunu inceleme ve seçme",
        1: "Sinema reklam türlerini inceleme ve seçme",
        2: "Komisyon veya ek ücret yok",
        3: "Sinema reklamlarının tek merkezden yönetimi",
      },
    },
    adsOnStudium: {
      title: "Stadyum ve Fuar Reklamları",
      description: "Markanızın en büyük merkezlerde yer alması",
      property: {
        0: "Reklam türü ve konumunu inceleme ve seçme",
        1: "Sinema reklam türlerini inceleme ve seçme",
        2: "Komisyon veya ek ücret yok",
        3: "Sinema reklamlarının tek merkezden yönetimi",
      },
    },
    bidOnline: {
      title: "Kapsamlı Online Açık Artırma Sistemi",
      description: "Online açık artırma düzenleyin, katılın",
      property: {
        0: "Reklam türü ve konumunu inceleme ve seçme",
        1: "Sinema reklam türlerini inceleme ve seçme",
        2: "Komisyon veya ek ücret yok",
        3: "Sinema reklamlarının tek merkezden yönetimi",
      },
    },
    onlineTools: {
      title: "Online İş Araçları Sistemi",
      description: "Her türlü işletme için yardımcı tüm araçlar",
      property: {
        0: "Reklam türü ve konumunu inceleme ve seçme",
        1: "Sinema reklam türlerini inceleme ve seçme",
        2: "Komisyon veya ek ücret yok",
        3: "Sinema reklamlarının tek merkezden yönetimi",
      },
    },
    onlineLearn: {
      title: "Online Meslek Eğitimi Sistemi",
      description: "Hedefli eğitim inceleme ve seçimi",
      property: {
        0: "Reklam türü ve konumunu inceleme ve seçme",
        1: "Sinema reklam türlerini inceleme ve seçme",
        2: "Komisyon veya ek ücret yok",
        3: "Sinema reklamlarının tek merkezden yönetimi",
      },
    },
    cloud: {
      title: "Hosting ve Domain Satın Alma",
      description: "Hosting, domain ve sunucu satın alma",
      property: {
        0: "Reklam türü ve konumunu inceleme ve seçme",
        1: "Sinema reklam türlerini inceleme ve seçme",
        2: "Komisyon veya ek ücret yok",
        3: "Sinema reklamlarının tek merkezden yönetimi",
      },
    },
    QrlandShop: {
  title: "Çevrimiçi Mağaza Yönetimi",
  description: "Ürünlerin, pazaryerlerinin ve akıllı fiyatlandırmanın entegre yönetimi",
  property: {
    0: "Ürünlerin kapsamlı takibi ve yönetimi",
    1: "Ürün varyantlarının yönetimi",
    2: "Pazaryerlerinin takibi ve yönetimi",
    3: "Akıllı fiyatlandırma stratejileri",
  },
},

  },

  "planning.title": "Planlama",
  "tabs.reminder": "Hatırlatıcı",
  "tabs.notes": "Notlar",
  "tabs.calendar": "Takvim",
  "notes.creationDate": "Oluşturulma Tarihi",
  "common.save": "Kaydet",
  "common.cancel": "İptal",
  "actions.quickActions": "Hızlı İşlemler",
  "notes.writeMessage": "Mesaj Yaz",
  "notes.titlePlaceholder": "Not Başlığı",
  "notes.addNote": "Not Ekle",
  "notes.updatedSuccess": "Not başarıyla güncellendi.",
  "notes.addedSuccess": "Not başarıyla eklendi.",
  "common.deletedSuccess": "Başarıyla silindi",
  "common.confirmDelete": "Silmek istediğinizden emin misiniz?",
  "news.title": "Site Haberleri",
  "news.noNews": "Sitede henüz haber kaydedilmemiş.",
  "news.view": "Görüntüle",
  "remember.add": "Hatırlatıcı Oluştur",
  "remember.update": "Hatırlatıcıyı Güncelle",
  "remember.titleLabel": "Başlık",
  "remember.dateLabel": "Hatırlatma Tarihi",
  "remember.confirmDelete": "Silmek istediğinizden emin misiniz?",
  "remember.deleteSuccess": "Hatırlatıcı başarıyla silindi.",
  "remember.createSuccess": "Yeni hatırlatıcı oluşturuldu.",
  "remember.updateSuccess": "Hatırlatıcı güncellendi.",
  "points.receivedAwards": "Alınan Ödüller",
  "points.pointsHistory": "Puan Geçmişi",
  "points.points": "Puan",
  "points.discountTitle": "Robot Land İndirimi",
  "points.discountText": "Her 500 puanda",
  events: {
    title: "Etkinlikler",
    addEvent: "Etkinlik Ekle",
    calendar: "Temel Takvim",
    close: "Kapat",
    save: "Kaydet",
    update: "Güncelle",
    confirmDelete: "Silmek istediğinizden emin misiniz?",
    successAdd: "Başarıyla eklendi.",
    successDelete: "Etkinlik başarıyla silindi.",
    successUpdate: "Güncelleme başarılı.",
    titleLabel: "Başlık",
    descriptionLabel: "Açıklama",
    colorLabel: "Renk",
    removeAfterDrop: "Bıraktıktan sonra kaldır",
    createEvent: "Etkinlik Oluştur",
  },
  copySuccess: "Başarıyla kopyalandı.",
  copyTextTitle: "Kopyala",
  copiedTextTitle: "Kopyalandı",
  ribbon: {
    new: "Yeni",
  },
  coupons: [
    {
      text: "Bu kupon 3 hafta geçerlidir",
      title: "Tekrarlanmayan Metin %20",
    },
    {
      text: "Bu kupon 2 hafta geçerlidir",
      title: "Web Tasarım %5",
    },
    {
      text: "Bu kupon sadece bir kez kullanılabilir",
      title: "Sayfa Yönetimi %10",
    },
    {
      text: "Bu kupon sizde kalıcı olarak aktif edildi",
      title: "Grafik Tasarım %5",
    },
    {
      text: "Bu kupon sadece bir kez kullanılabilir",
      title: "Baskı %2",
    },
  ],
  userLinks: {
    profile: {
      title: "Genel Bakış",
      invitation: { title: "Arkadaş Davet Et" },
      info: { title: "Kişisel Bilgiler" },
      edit: { title: "Profil Tamamla" },
      changePass: { title: "Şifre Değiştir" },
    },
  },
  profileLinks: {
    orders: "Siparişler",
    addresses: "Adresler",
  },
  customPage: {
    overview: "Genel Bakış",
    personalInfo: "Kişisel Bilgiler",
    changePassword: "Şifre Değiştir",
    completeProfile: "Profil Tamamla",
    email: "E-posta",
    balance: "Bakiye",
    phone: "Telefon Numarası",
    rial: "Riyal",
  },
  widget12: {
    inviteFriends: "Arkadaş Davet Et",
    viewInvitedUsers: "Sizin davet ettiğiniz kullanıcıları gör",
    yourInviteCode: "Davet Kodunuz",
    createNewUser: "Yeni Kullanıcı Oluştur",
    copyText: "Kopyala",
    userCreatedSuccess: "Yeni kullanıcı başarıyla oluşturuldu",
    notCreated: "Oluşturulmadı",
  },
  userInfo: {
    userInformation: "Kullanıcı Bilgileri",
    profilePicture: "Profil Fotoğrafı",
    allowedFileTypes: "İzin verilen dosya türleri: png, jpg, jpeg.",
    profilePictureSize:
      "Profil fotoğrafı aynı boyutta olmalı (örnek: 480 × 480).",
    firstName: "Ad",
    lastName: "Soyad",
    username: "Kullanıcı Adı",
    phone: "İletişim Numarası",
    email: "E-posta",
    receiveSMS: "SMS Al",
    smsCostNote:
      "Bu seçeneği aktif ederseniz SMS gönderme ücreti hesabınızdan düşer.",
    saveChanges: "Değişiklikleri Kaydet",
    profileUpdated: "Profiliniz başarıyla güncellendi.",
  },
  emailSettings: {
    completeProfile: "Profil Tamamla",
    completeProfileDesc: "Kişi veya kurum bilgilerini tamamlayın",
    cancel: "İptal",
    update: "Güncelle",
    save: "Kaydet",
    selectPersonType: "Kişi türünü seçin",
    realPerson: "Gerçek Kişi",
    legalPerson: "Tüzel Kişi",
    phone: "Cep Telefonu",
    landline: "Sabit Telefon",
    fatherName: "Baba Adı",
    nationalCode: "Kimlik Numarası",
    idNumber: "Kimlik Belge No",
    birthday: "Doğum Tarihi",
    placeOfBirth: "Doğum Yeri",
    postalCode: "Posta Kodu",
    email: "E-posta",
    introduction: "Nasıl tanıdınız?",
    nationalCodePic: "Kimlik Kartı Fotoğrafı",
    plaque: "Plaka",
    address: "Tam Adres",
    companyName: "Şirket/Mağaza Adı",
    registrationNumber: "Kayıt Numarası",
    economicCode: "Ekonomik Kod",
    organizationIdentity: "Kurumsal Kimlik Numarası",
    companyType: "Şirket Türü",
    activity: "Faaliyet Alanı",
    registrationAd: "Şirket Kayıt İlanı Fotoğrafı",
    lastPublishedAd: "Son Resmi İlan Fotoğrafı",
    statute: "Şirket Ana Sözleşmesi Fotoğrafı",
    agentLetterPic: "Vekaletname Fotoğrafı",
    successMessage: "Başarıyla kaydedildi",
    errorSelectType: "Lütfen bir seçenek seçin.",
    rules: {
      companyName: "Şirket/mağaza adı alanı zorunludur.",
      registrationNumber: "Kayıt numarası zorunludur.",
      economicCode: "Ekonomik kod zorunludur.",
      organizationIdentity: "Kurumsal kimlik numarası zorunludur.",
      registrationAd: "Şirket kayıt ilanı fotoğrafı zorunludur.",
      lastPublishedAd: "Son resmi ilan fotoğrafı zorunludur.",
      telephone: "Sabit telefon zorunludur.",
      fatherName: "Baba adı zorunludur.",
      nationalCode: "Kimlik numarası zorunludur.",
      birthday: "Doğum tarihi zorunludur.",
      idNumber: "Kimlik belge no zorunludur.",
      placeOfBirth: "Doğum yeri zorunludur.",
      postalCode: "Posta kodu zorunludur.",
      nationalCodePic: "Kimlik kartı fotoğrafı zorunludur.",
      address: "Adres zorunludur.",
      plaque: "Plaka zorunludur.",
    },
    companyTypes: {
      governmental: "Devlet",
      private: "Özel",
      commonStock: "Halka Açık Anonim",
      specialStock: "Kapalı Anonim",
    },
  },
  changePassword: {
    title: "Şifre Değiştir",
    description: "Hesap şifrenizi değiştirin",
    cancel: "İptal",
    update: "Güncelle",
    passwordInstructions: {
      forgotPassword:
        "Henüz şifre belirlemediyseniz 'Şifremi Unuttum' seçeneğine tıklayabilirsiniz.",
      passwordRequirements:
        "Şifre en az 8 karakter olmalı, büyük-küçük harf, rakam ve sembol içermelidir.",
      passwordPrivacy: "Lütfen şifrenizi kimseyle paylaşmayın.",
      keyboardLanguage:
        "Şifre belirlerken klavyenizin İngilizce olduğundan emin olun.",
    },
    currentPassword: "Mevcut Şifre",
    newPassword: "Yeni Şifre",
    confirmNewPassword: "Yeni Şifreyi Tekrarla",
    addOrForgotPassword: "Şifre Ekle veya Unuttum",
    changePasswordWithCode: "Numarayla Şifre Değiştir",
    close: "Kapat",
    change: "Değiştir",
    enterCode: "Kodu girin",
    successMessage: "Şifre başarıyla güncellendi",
    invalidCode: "Kod hatalı.",
    tooManyAttempts: "Çok fazla deneme yaptınız!",
    rules: {
      required: "Bu alan zorunludur.",
      min: "Şifre 8 karakterden kısa olamaz",
      equal: "Şifreler eşleşmiyor",
      number: "Telefon numarasını girin",
    },
  },
  router: {
    dashboard: "Panel",
    contacts: "Müşteri Kulübü",
    editContact: "Müşteri Düzenle",
    createContact: "Müşteri Oluştur",
    customers: "Müşteri Listesi",
    contactList: "İletişim Yardımcısı",
    messages: "Mesajlar",
    messageCategories: "Mesaj Kategorileri",
    oldTransactions: "Eski İşlemler",
    yourTransactions: "İşlemleriniz",
    buyPanel: "Panel Satın Al",
    permissions: "Yetkiler",
    createPermission: "Yetki Oluştur",
    invitations: "Davet Ettiklerim",
    editUser: "Kullanıcı Düzenle",
    userInformation: "Kullanıcı Bilgileri",
    walletEdit: "Kullanıcı Cüzdanı Düzenle",
    userHistory: "Kullanıcı Geçmişi",
    userNotificationsHistory: "Kullanıcı Bildirim Geçmişi",
    notifications: "Bildirimler",
    createNotification: "Bildirim Oluştur",
    editNotification: "Bildirim Düzenle",
    adminNotifications: "Yönetici Bildirimleri",
    yourNotifications: "Bildirimleriniz",
    adminNotificationsList: "Yönetici Bildirimleri",
    tickets: "Destek Talepleri",
    createTicket: "Yeni Talep Oluştur",
    editTicket: "Talep Düzenle",
    departments: "Departmanlar",
    createDepartment: "Yeni Departman",
    editDepartment: "Departman Düzenle",
    adminTickets: "Talep Yönetimi",
    discounts: "İndirimler",
    createDiscount: "İndirim Oluştur",
    editDiscount: "İndirim Düzenle",
    workReports: "İş Raporları",
    createWorkReport: "İş Raporu Oluştur",
    callMonitoring: "Arama İzleme",
    adminWorkReports: "İş Raporu Yönetimi",
    editWorkReport: "Rapor Görüntüle ve Düzenle",
    packProperties: "Paket Özellikleri",
    createPackProperty: "Paket Özelliği Oluştur",
    editPackProperty: "Paket Özelliği Düzenle",
    panels: "Paneller",
    createPanel: "Panel Oluştur",
    editPanel: "Panel Düzenle",
    transferRequests: "Çekim Talepleri",
    editTransferRequest: "Çekim Talebi Düzenle",
    tariffs: "Tarifeler",
    createTariff: "Tarife Oluştur",
    editTariff: "Tarife Düzenle",
    requests: "Talepler",
    viewUser: "Kullanıcı Görüntüle",
    manageTransactions: "İşlem Yönetimi",
    viewTransaction: "İşlem Görüntüle",
    manageConfigs: "Ayarlar Yönetimi",
    rbLandConfigs: "Robot Land Ayarları",
    editConfig: "Ayarları Düzenle",
    manageUsers: "Kullanıcı Yönetimi",
    categories: "Kategoriler",
    createCategory: "Kategori Ekle",
    editCategory: "Kategori Düzenle",
    content: "İçerik",
    createContent: "İçerik Ekle",
    editContent: "İçerik Düzenle",
    addUserGuide: "Kullanıcı Kılavuzu Ekle",
    editUserGuide: "Kullanıcı Kılavuzu Düzenle",
    roles: "Roller",
    editRole: "Rol Düzenle",
    createRole: "Rol Ekle",
    permissionTitle: "Yetkiler",
    paymentGateways: "Ödeme Kapıları",
    editPaymentGateway: "Ödeme Kapısı Düzenle",
    campaigns: "Kampanyalar",
    createCampaign: "Kampanya Oluştur",
    editCampaign: "Kampanya Düzenle",
    adminCustomers: "Müşteriler",
    createCustomer: "Müşteri Oluştur",
    editCustomerInfo: "Müşteri Bilgilerini Düzenle",
    referrerCustomers: "Tavsiye Eden Müşteriler",
    customerHistory: "Müşteri Geçmişi",
    userProfile: "Kullanıcı Profili",
    editProfile: "Profil Düzenle",
    inviteFriends: "Arkadaş Davet Et",
    personalInfo: "Kişisel Bilgiler",
    editPersonalInfo: "Bilgileri Düzenle",
    changePassword: "Şifre Değiştir",
    newWallet: "Yeni Cüzdan",
  },
  profileView: {
    email: "E-posta",
    balance: "Bakiye",
    personType: "Kişi Türü",
    currency: "Riyal",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "Sizde {title} paneli var, {days} günlük.",
    buyOrRenew:
      "Panel satın almak veya yenilemek için aşağıdaki butona tıklayın.",
    buyPanel: "Panel Satın Al",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "Profil Ayarları",
    changePasswordTitle: "Giriş Şifresi Değiştir",
    changePasswordSubtitle: "Hesap giriş şifrenizi değiştirin.",
    alertMessage:
      "Henüz şifre belirlemediyseniz 'Şifre Belirle' seçeneğini aktif edin.",
    currentPasswordLabel: "Mevcut Şifre",
    setPasswordLabel: "Şifre Belirle",
    addPassword: "Şifre Ekle",
    newPasswordLabel: "Yeni Şifre",
    repeatPasswordLabel: "Şifreyi Tekrarla",
    saveChanges: "Değişiklikleri Kaydet",
    currentPasswordPlaceholder: "Mevcut şifre",
    newPasswordPlaceholder: "Yeni şifre",
    repeatPasswordPlaceholder: "Şifreyi tekrarla",
  },
  profileOrders: {
    cardTitle: "Siparişler",
    openOrders: "Açık Siparişler ({count})",
    closedOrders: "Kapanmış Siparişler ({count})",
    noOrders: "Henüz siparişiniz yok",
  },
  personalInformation: {
    cardTitle: "Hesap Kişisel Bilgileri",
    cardSubtitle: "Kişisel bilgilerinizi güncelleyin.",
    cancel: "İptal",
    update: "Güncelle",
    yourInfo: "Bilgileriniz",
    profilePicture: "Profil Fotoğrafı",
    allowedFileTypes: "İzin verilen dosya türleri: png, jpg, jpeg.",
    pictureSize: "Profil fotoğrafı aynı boyutta olmalı (örnek: 480 × 480).",
    name: "Ad",
    lastName: "Soyad",
    username: "Kullanıcı Adı",
    receiveSMS: "SMS Al",
    smsCostNote: "Bu seçeneği aktif ederseniz SMS ücreti hesabınızdan düşer.",
    phoneNumber: "Cep Telefonu",
    phonePlaceholder: "Cep telefonu",
    email: "E-posta",
    emailPlaceholder: "E-posta",
    emailPrivacy: "E-postanızı asla başkasıyla paylaşmayız.",
    successMessage: "Profiliniz başarıyla güncellendi.",
  },
  userInfoForm: {
    companyName: "Şirket/Mağaza Adı",
    registrationNumber: "Kayıt Numarası",
    economicCode: "Ekonomik Kod",
    organizationIdentity: "Kurumsal Kimlik Numarası",
    companyType: "Şirket Türü",
    activity: "Faaliyet Alanı",
    registrationAd: "Şirket Kayıt İlanı Fotoğrafı",
    lastPublishedAd: "Son Resmi İlan Fotoğrafı",
    statute: "Şirket Ana Sözleşmesi Fotoğrafı",
    argentLetterPic: "Vekaletname Fotoğrafı",
    phone: "Cep Telefonu",
    telephone: "Sabit Telefon",
    fatherName: "Baba Adı",
    nationalCode: "Kimlik Numarası",
    id: "Kimlik Belge No",
    birthday: "Doğum Tarihi",
    placeBirthday: "Doğum Yeri",
    postalCode: "Posta Kodu",
    email: "E-posta",
    introduction: "Nasıl tanıdınız?",
    nationalCodePic: "Kimlik Kartı Fotoğrafı",
    plaque: "Plaka",
    address: "Tam Adres",
    companyTypes: {
      governmental: "Devlet",
      private: "Özel",
      common_stock: "Halka Açık Anonim",
      special_stock: "Kapalı Anonim",
    },
    rules: {
      companyName: "Şirket/mağaza adı zorunludur.",
      registration_number: "Kayıt numarası zorunludur.",
      economic_code: "Ekonomik kod zorunludur.",
      organization_identity: "Kurumsal kimlik numarası zorunludur.",
      registration_ad: "Şirket kayıt ilanı zorunludur.",
      last_published_ad: "Son resmi ilan zorunludur.",
      telephone: "Sabit telefon zorunludur.",
      fatherName: "Baba adı zorunludur.",
      nationalCode: "Kimlik numarası zorunludur.",
      id: "Kimlik belge no zorunludur.",
      birthday: "Doğum tarihi zorunludur.",
      placeBirthday: "Doğum yeri zorunludur.",
      postalCode: "Posta kodu zorunludur.",
      nationalCodePic: "Kimlik kartı fotoğrafı zorunludur.",
      address: "Adres zorunludur.",
      plaque: "Plaka zorunludur.",
    },
  },
  createUserForm: {
    name: "Ad",
    lastName: "Soyad",
    nid: "Kimlik Numarası",
    phone: "Cep Telefonu",
    create: "Oluştur",
    errors: {
      nameRequired: "Ad girilmedi!",
      lastNameRequired: "Soyad girilmedi!",
      nidRequired: "Kimlik numarası girilmedi!",
      phoneRequired: "Telefon girilmedi!",
    },
  },
  lastView: {
    cardTitle: "Son Ziyaretleriniz",
    cardSubtitle: "Sayfalarımızdaki son ziyaretleriniz",
    tableHeaders: {
      page: "Sayfa",
      address: "Adres",
      enterDate: "Giriş Tarihi",
      leaveDate: "Çıkış Tarihi",
      timeSpent: "Geçirilen Süre",
    },
    viewAll: "Tümünü Gör",
    timeUnit: "dakika",
    pages: {
      home: "Ana Sayfa",
      panels: "Paneller",
      profile: "Profil Tamamlama",
    },
  },
walletWidget: {
  title: "Son İşlemler",
  balanceLabel: "Bakiyeniz:",
  viewTransactions: "İşlemleri Görüntüle",
  transactionTypes: {
    withdraw: "Para Çekme",
    deposit: "Para Yatırma",
    charge: "Cüzdan Yükleme",
    refund: "İade",
    default: "İşlem",
    adminCharge: "Yönetici İşlemi",
    agency: "Acentelik Komisyonu",
  },
},
  panelWidget: {
    title: "Sizde {title} paneli var, {days} günlük.",
    renewPrompt: "Satın almak veya yenilemek için aşağıdaki butona tıklayın.",
    buyPanel: "Panel Satın Al",
    percentage: "%{value}",
    infinity: "∞",
    days: "{count} gün",
  },
  component: {
    title: "Sizin davet ettiğiniz kullanıcılar",
    columns: {
      row: "Sıra",
      name: "Ad",
      family: "Soyad",
      username: "Kullanıcı Adı",
      phone: "Cep Telefonu",
      created_at: "Üyelik Tarihi",
      actions: "İşlemler",
    },
    unknown: "Bilinmiyor",
    error: "Hata",
    breadcrumb: "Davet Edilen Kullanıcılar",
  },
  table: {
    itemsPerPage: "Sayfa başına satır sayısı",
    pageText: "{0}-{1} arası, toplam {2} kayıt",
    prevText: "Önceki",
    nextText: "Sonraki",
    noDataText: "Veri yok",
    search: "Ara",
  },
  UserHistory: {
    title: "Kullanıcı Geçmişi",
    add_history: "Yeni Geçmiş Kaydı",
    send_message: "Mesaj Gönder",
    close: "Kapat",
    save: "Kaydet",
    cancel: "İptal",
    new_history_dialog_title: "Yeni Geçmiş Kaydı",
    send_message_dialog_title: "Mesaj Gönder",
    negotiations: "Yapılan Görüşmeler",
    follow_up: "Sonraki Aramda Takip Edilecekler",
    success_history: "Geçmiş başarıyla kaydedildi.",
    success_message: "Mesaj başarıyla gönderildi.",
    columns: {
      id: "ID",
      title: "Başlık",
      status: "Aşama",
      current_time_date: "Son Arama Tarihi",
      current_time_hour: "Son Arama Saati",
      next_time_date: "Sonraki Arama Tarihi",
      next_time_hour: "Sonraki Arama Saati",
      user_id: "Destek Elemanı",
      actions: "İşlemler",
    },
    table: {
      itemsPerPage: "Sayfa başına satır sayısı",
      pageText: "{0}-{1} arası, toplam {2} kayıt",
      prevText: "Önceki",
      nextText: "Sonraki",
      noDataText: "Veri yok",
      search: "Ara",
    },
    form: {
      title: "Başlık",
      status: "Aşama",
      current_time: "Son Arama Tarihi",
      description: "Açıklama",
      next_time: "Sonraki Arama Tarihi",
      pursue_text: "Sonraki Aramda Takip",
      category: "Kategori Seç",
      message_title: "Mesaj Başlığı",
    },
  },
  newUserTransactions: {
    userWallet: "Kullanıcı Cüzdanı",
    transactionList: "İşlem Listesi",
    userTransactions: "Kullanıcı İşlemleri",
    terminal: "Terminal",
    liveSms: "Canlı SMS",
    realEstateNews: "Divar Güncel",
    rial: "Riyal",
    row: "Sıra",
    uniqueId: "ID",
    amount: "Tutar",
    time: "Saat",
    createdAt: "Tarih",
    description: "Açıklama",
    type: "İşlem Türü",
    product_description: "Açıklama",
    serviceId: "Servis Adı",
    balanceAfter: "Kalan Bakiye",
    perPage: "Sayfa başına",
    search: "Ara",
    balance: "Bakiye",
    transactionListTooltip: "İşlem Listesi",
    panelLogin: "Panele Giriş",
    history: "Geçmiş",
    error: {
      terminalWallet: "Terminal cüzdanı alınırken hata",
    },
    transactionType: "İşlem Türü",
    service: "Servis",
    dateFrom: "Başlangıç Tarihi",
    dateTo: "Bitiş Tarihi",
    oldWallet: "Eski Cüzdan",
    depositReceipt: "Yatırma Fişi",
    showReceipt: "Fişi Göster",
    transactionTypes: {
      online: "Online",
      admin: "Yönetici Tarafından",
      refund: "Düzeltme İşlemi",
      agency: "Acentelik",
      withdraw: "Çekim",
      deposit: "Yatırma",
      adminCharge: "Yönetici Şarjı",
      charge: "Cüzdan Şarj",
      refund: "İade",
    },
    error: {
      imageLoad: "Resim yüklenirken hata!",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "Lütfen panel türünü seçerken dikkatli olun!",
    },
    dialog: {
      title: "Panel Satın Al",
      confirmPurchase:
        "{title} panelini satın almak istediğinizden emin misiniz?",
      discountCodeLabel: "İndirim Kodu",
      discountCodePlaceholder: "İndirim kodunuzu girin",
      applyDiscount: "Kodu Uygula",
      purchase: "Satın Al",
      iHaveDiscount: "İndirim kodum var",
    },
    toast: {
      discountApplied: "İndirim kodu başarıyla uygulandı!",
      purchaseSuccess: "Paket başarıyla satın alındı",
      error: "Hata oluştu: {message}",
      unauthorized: "Lütfen önce giriş yapın",
      validationError: "Doğrulama hatası: {message}",
    },
    currency: "Riyal",
  },
  panelCard: {
    rial: "Riyal",
    days: "günlük",
    buyPanel: "Panel Satın Al",
  },
  cons: {
    title: "Emoji Seç",
  },
  cons1: {
    title: "Varsayılan Metin",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "Büyük Reklam Terminali Sistemi",
  },
};
